import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import RadioButtonUncheckedTwoToneIcon from "@material-ui/icons/RadioButtonUncheckedTwoTone";
import Person from "../img/1.jpg";
import { notifications } from "../data/notification";

export default class Notifications extends React.Component {
	classes = {
		root: "makeStyles-root-190",
		inline: "makeStyles-inline-191"
	};

	render() {
		return (
			<List className={this.classes.root} style={{ maxWidth: "none" }}>
				{notifications.map((notification, index) => (
					<div>
						<Notification data={notification} />
						{index < notifications.length - 1 && <Divider component="li" />}
					</div>
				))}
			</List>
		);
	}
}

export class Notification extends React.Component {
	state = this.props.data;

	classes = {
		root: "makeStyles-root-190",
		inline: "makeStyles-inline-191"
	};

	handleRead = () => {
		this.setState({
			unread: !this.state.unread
		});
	};

	render() {
		return (
			<ListItem
				alignItems="flex-start"
				style={
					this.state.unread
						? { background: "#e4e9f1" }
						: { background: "transparent" }
				}
			>
				<ListItemAvatar>
					<Avatar alt="Remy Sharp" src={Person} />
				</ListItemAvatar>
				<ListItemText
					primary={
						<React.Fragment>
							{this.state.type === "reminder" && "Reminder: "}
							<Typography
								component="span"
								variant="body2"
								className={this.classes.inline}
								color="textPrimary"
								style={{ fontWeight: 500 }}
							>
								{this.state.from}
							</Typography>
							{" " + this.state.body}
						</React.Fragment>
					}
					secondary={this.state.timestamp}
				/>
				<ListItemSecondaryAction>
					<IconButton onClick={this.handleRead}>
						{this.state.unread ? (
							<Tooltip title="Mark as Read" placement="top">
								<FiberManualRecordIcon fontSize="small" />
							</Tooltip>
						) : (
							<Tooltip title="Mark as Unread" placement="top">
								<RadioButtonUncheckedTwoToneIcon fontSize="small" />
							</Tooltip>
						)}
					</IconButton>
				</ListItemSecondaryAction>
			</ListItem>
		);
	}
}
